import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

export const Block: React.FC<sharedComponents.Block> = ({
  headerComponent,
  contentComponent,
  isHeaderUnderlined = true,
  isContentUnderlined = true,
}) => (
  <div className={styles.contentBlock}>
    <div className={classNames(styles.headerBox, { [styles.headerUnderlined]: isHeaderUnderlined })}>
      { headerComponent }
    </div>
    <div
      className={classNames(styles.contentBox, {
        [styles.contentUnderlined]: isContentUnderlined,
      })}
    >
      { contentComponent }
    </div>
  </div>
);
